import { useEffect, useRef } from "react";

export default function CtaSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const children = entry.target.querySelectorAll(".cta-animate");
            children.forEach((child, i) => {
              setTimeout(() => child.classList.add("visible"), i * 120);
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="cta"
      ref={sectionRef}
      className="relative py-20 md:py-28 bg-[#f5f5f7] overflow-hidden"
    >
      <div className="max-w-[1024px] mx-auto px-6">
        <div className="max-w-[680px] mx-auto text-center">
          <h2 className="cta-animate animate-on-scroll text-[32px] sm:text-[40px] lg:text-[48px] font-semibold leading-[1.1] tracking-tight text-[#1d1d1f] mb-5">
            Отримайте безкоштовний
            <br />
            <span className="gradient-text-shimmer">аудит воронки найму + демо</span>
          </h2>
          <p className="cta-animate animate-on-scroll text-[17px] text-[#86868b] leading-relaxed max-w-[520px] mx-auto mb-12">
            Покажемо, які джерела, міста або етапи забирають найбільше часу й грошей.
          </p>
        </div>

        <div className="max-w-[420px] mx-auto mb-10">
          <p className="cta-animate animate-on-scroll text-[12px] font-medium text-[#1d1d1f] tracking-wide uppercase mb-5 text-center">
            Що отримаєте
          </p>
          <ul className="space-y-4">
            {[
              "Розбір воронки найму",
              "Карту втрат кандидатів",
              "Оцінку вартості простою вакансій",
              "План пілоту без зупинки поточного найму",
            ].map((item, i) => (
              <li
                key={i}
                className="cta-animate animate-on-scroll flex items-center gap-3 text-[17px] text-[#1d1d1f]"
              >
                <div className="w-8 h-8 rounded-full bg-[#e8e8ed] flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-[16px] text-[#1d1d1f]" />
                </div>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="cta-animate animate-on-scroll text-center">
          <a
            href="https://hurma.work/request-2/?utm_source=retail_landing&utm_medium=demo&utm_campaign=2026"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 gradient-bg text-white text-sm sm:text-[15px] font-medium px-5 sm:px-8 py-3 sm:py-4 rounded-full hover:opacity-90 transition-opacity text-center whitespace-normal sm:whitespace-nowrap w-full sm:w-auto"
          >
            Отримати безкоштовний аудит воронки найму
          </a>
        </div>
      </div>
    </section>
  );
}